import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import './css/HomePage1Players.css';
import { useHistory, NavLink } from 'react-router-dom';
import { context } from '../../../../../globalState/GlobalState';
import Spinner1 from '../../../../uiElements/spinners/spinner1/Spinner1';
import Button1 from '../../../../uiElements/buttons/Button1';
import { fetchLimitedPlayersForHomepageAPI } from '../../../../apiCalls/PlayerAPICalls';
import { isValidObject, isValidString } from '../../../../../catalog/Validity';
import { getOptimXBackgroundStyle } from '../../../../../catalog/Website';
import DemoPlayer from '../../../../../assets/demoIceHockeyPlayer.png';

const initialState = {
    players: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchPlayers':
            return { ...state, players: action.players };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1Players = () => {
    const history = useHistory();
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchPlayers() {
            if (state.players.length <= 0) {
                setState({ type: 'setLoadingSpinner', loadingSpinner: true });
                await fetchLimitedPlayersForHomepageAPI(globalState.accountId, false, 5, setState, enqueueSnackbar);
                setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            }
        }
        fetchPlayers();
    }, []);

    const getTeamNumber = (details) => {
        let teamNumber = '';
        details.forEach((detail) => {
            if (detail.title === 'Team Number') {
                teamNumber = detail.value;
            }
        });
        return teamNumber;
    };

    return (
        <>
            {state.players.length > 0 ? (
                <div className="homepage1-players-container full-width box-shadow-black p-t-20px p-l-20px p-r-20px p-b-20px">
                    <div className="homepage1-players-title p-l-100px p-r-20px">
                        <p className="alegreya-font-family font-weight-800 font-size-5xl text-uppercase text-left-align m-t-0 m-b-0">Check out Roster</p>
                        <Button1
                            title="Roster"
                            disabled={state.loadingSpinner || state.players.length === 0}
                            showArrow
                            transparent
                            backgroundColor={globalState.websiteStyles.colors.primaryColor}
                            fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                            fontSize="1.2rem"
                            borderRadius="10px"
                            onClick={() => { history.push('/roster'); }}
                        />
                    </div>
                    <div className="homepage1-players p-l-20px p-r-20px">
                        {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (<img className="homepage1-logo m-l-50px m-r-50px" src={globalState.logo.logo2} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />) : null}
                        {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} marginTop={20} />) : (
                            <>
                                {state.players.map((player) => {
                                    return (
                                        <NavLink to={`/roster/${player.id}`} key={player.id} className="homepage1-player-container curve-border-20px box-shadow-black text-black text-no-underline m-l-10px m-r-10px">
                                            {isValidString(player.profileImage)
                                                ? (<img className="homepage1-player-image curve-border-20px" src={player.profileImage} loading="lazy" alt={isValidString(player.name) ? player.name : 'Player Profile Image'} />)
                                                : (<img className="homepage1-player-image curve-border-20px" src={DemoPlayer} loading="lazy" alt={isValidString(player.name) ? player.name : 'Player Profile Image'} />)}
                                            <p className="homepage1-player-name alegreya-font-family font-weight-800 text-white m-t-0 m-b-0 text-center-align text-uppercase font-size-xl">{player.name}</p>
                                            <p className="homepage1-player-team-number text-white m-t-0 m-b-0 p-t-5px p-b-5px p-l-10px p-r-10px curve-border-5px text-center-align font-size-l" style={getOptimXBackgroundStyle(globalState)}>{getTeamNumber(player.details)}</p>
                                        </NavLink>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default memo(HomePage1Players);
